<template>
  <div class="live-virtual-training__section">
    <div class="live-virtual-training__title">Live Virtual Training Events</div>
    <div class="live-virtual-training__subtitle">
      INE's Live Virtual Training combines live, instructor-led with INE's on-demand, hands-on labs
      to get the ultimate learning experience.
    </div>
    <div v-if="activeLiveVirtualTrainings" class="live-virtual-training__card-items">
      <PlanItemLiveVirtualTrainingCard
        v-for="liveVirtualTraining in liveVirtualTrainings"
        :key="liveVirtualTraining.id"
        :liveVirtualTraining="liveVirtualTraining"
        :displayCoupon="displayCoupon"
        :LVTCoupon="LVTCoupon"
      />
    </div>
    <div v-else class="live-virtual-training__no-events">
      <LiveVirtualTrainingSectionEmpty />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LiveVirtualTrainingSectionEmpty from '@/components/shop-sections/LiveVirtualTrainingSectionEmpty.vue'
import PlanItemLiveVirtualTrainingCard from '@/components/plan-item-card/PlanItemLiveVirtualTrainingCard.vue'

export default {
  name: 'LiveVirtualTrainingSection',
  components: {
    PlanItemLiveVirtualTrainingCard,
    LiveVirtualTrainingSectionEmpty,
  },
  props: {
    displayCoupon: {
      type: Boolean,
      default: false,
    },
    LVTCoupon: {
      type: Object,
    },
  },
  computed: {
    ...mapState({
      liveVirtualTrainings: state => state.products.availableLiveVirtualTrainings,
    }),
    activeLiveVirtualTrainings() {
      return this.liveVirtualTrainings.length > 0
    },
  },
}
</script>

<style lang="scss">
.live-virtual-training {
  &__section {
    text-align: left;
    border-top: 1px solid var(--mid-gray-translucid);
    padding-top: 60px;
    margin-top: 40px;
  }
  &__title {
    font-family: var(--font-medium);
    font-weight: 450;
    font-size: rem(24px);
    line-height: rem(32px);
    margin-bottom: 10px;
  }
  &__subtitle {
    color: var(--light-blue-gray);
    font-size: rem(18px);
    font-style: normal;
    font-weight: 500;
    line-height: rem(24px);
    margin-bottom: 30px;
  }
  &__card-items {
    margin-bottom: 30px;
    display: flex;
    flex-flow: wrap;
    gap: 20px;
  }
}
</style>
